import axios from 'axios'

const baseUrl = '/api/1.0/authentication'

export default {
  getMe() {
    return axios.get(`${baseUrl}/me`)
  },

  verify2FA(payload) {
    return axios.post(`${baseUrl}/verify-2fa`, payload)
  },

  toggle2FA(payload) {
    return axios.post(`${baseUrl}/toogle-2fa`, payload)
  },

  sendCode2FA() {
    return axios.post(`${baseUrl}/sendcode-2fa`)
  },

  getQrUri() {
    return axios.get(`${baseUrl}/qr-2fa`)
  } 
}

